import { Link } from "react-router-dom";
import cartItemImage from "../../assets/images/pro-2.png";
import Select from "../../components/Select";

const CartItem = () => {
  const quantities = [
    {
      id: 0,
      value: "59",
      text: "59",
    },
    {
      id: 1,
      value: "12",
      text: "12",
    },
    {
      id: 2,
      value: "20",
      text: "20",
    },
  ];
  return (
    <div className="py-4 flex xs:flex-col lg:flex-row">
      <div className="cart-item px-4 flex xs:flex-col md:flex-row xs:w-full lg:w-9/12">
        <div className="image flex justify-center">
          <Link to="">
            <img src={cartItemImage} alt="" />
          </Link>
        </div>
        <div className="details pl-4">
          <div>
            <div className="title text-lg">
              <Link to="">
                <h4>Nike React Miler Shield Nike React Miler Shield</h4>
              </Link>
            </div>
            <div className="desc text-base text-[#7d7d7d]">
              <p>Description for product item number 1</p>
            </div>
            <div className="specs pt-1 flex text-[13px] font-normal flex-wrap">
              <div className="single-spec pr-3 last:pr-0 flex items-center">
                <span className="pr-1 text-black/60">Color:</span>
                <span>Black</span>
              </div>
              <div className="single-spec pr-3 last:pr-0 flex items-center">
                <span className="pr-1 text-black/60">Size:</span>
                <span>32oz</span>
              </div>
              <div className="single-spec pr-3 last:pr-0 flex items-center">
                <span className="pr-1 text-black/60">Warranty:</span>
                <span>3 Years</span>
              </div>
            </div>
            <div className="how-many text-[#8b8b8b] text-sm pt-2 flex items-center">
              <span className="pr-1">Piece: </span>
              <span>
                <Select
                  options={quantities}
                  selectedClasses={{ padding: "px-3 py-1" }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="price p-4 text-sm text-black font-medium xs:w-full lg:w-3/12 xs:text-left lg:text-right">
        <span className="pl-4">₺5.99</span>
      </div>
    </div>
  );
};

export default CartItem;
